export const allJurisdictionsCode = 'ALL';

export const JurisdictionType = Object.freeze({
    PRODUCTION: 'PRODUCTION',
    SIMULATION: 'SIMULATION'
});

/* A sandbox (SIMULATION) jurisdiction, as /general/brandsandjurisdictions lists it: a copy of a jurisdiction to play simulated players in. */
export const isSandboxJurisdiction = jurisdiction =>
    !!jurisdiction && jurisdiction.type === JurisdictionType.SIMULATION;

export const isSandboxBrand = brand =>
    !!brand && brand.type === JurisdictionType.SIMULATION;

/*
  Whether the data that a jurisdiction and a brand name together is read-only: it is in a sandbox, which is a jurisdiction of type
  SIMULATION or a brand (a run) of one. Either is enough, because a run is reached by its brand. Nothing in a sandbox's alerts can be
  dismissed, delegated, given a note or exported; the server refuses it with 409 SIMULATION_READ_ONLY.
*/
export const isReadOnlyScope = (jurisdiction, brand) =>
    isSandboxJurisdiction(jurisdiction) || isSandboxBrand(brand);
